import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { WorkspaceProvider } from '../../contexts/WorkspaceContext';
import Sidebar from './Sidebar';
import CommandPalette from '../CommandPalette';
import { Toaster } from 'sonner';
import { useState, useEffect } from 'react';

const MainLayout = () => {
  const { user, loading } = useAuth();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Listen for sidebar collapse changes
  useEffect(() => {
    const checkSidebar = () => {
      const sidebar = document.querySelector('.sidebar');
      if (sidebar) {
        setSidebarCollapsed(sidebar.classList.contains('w-16'));
      }
    };
    
    const observer = new MutationObserver(checkSidebar);
    const sidebar = document.querySelector('.sidebar');
    if (sidebar) {
      observer.observe(sidebar, { attributes: true, attributeFilter: ['class'] });
    }
    
    checkSidebar();
    return () => observer.disconnect();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin w-8 h-8 border-2 border-slate-900 border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/ats/login" replace />;
  }

  return (
    <WorkspaceProvider>
      <div className="min-h-screen bg-slate-50/50">
        <Sidebar />
        <CommandPalette />
        <main className={`transition-all duration-300 pt-0 md:pt-0 max-md:pb-[env(safe-area-inset-bottom)] ${sidebarCollapsed ? 'md:ml-16' : 'md:ml-64'}`}>
          <div className="md:hidden h-14"></div> {/* Spacer for mobile menu button */}
          <Outlet />
        </main>
        <div className="fixed bottom-1 right-2 text-[10px] text-slate-300 select-none pointer-events-none z-50" data-testid="build-stamp">
          Build 2026.08.27-P0
        </div>
        {/* Offsets built from env(safe-area-inset-top): without them sonner
            pins its toasts 32px from the top of the LAYOUT viewport, which on a
            phone is behind the address bar and inside the notch. */}
        <Toaster
          position="top-right"
          richColors
          closeButton
          offset={{ top: 'calc(env(safe-area-inset-top, 0px) + 16px)', right: '16px' }}
          mobileOffset={{ top: 'calc(env(safe-area-inset-top, 0px) + 12px)', left: '12px', right: '12px' }}
        />
      </div>
    </WorkspaceProvider>
  );
};

export default MainLayout;
